export enum EntryType {
  Default = 10,
  Intro = 20,
  Seller = 30,
  NewItem = 60,
  IdentityDocument = 70,
}
